import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Barcode from '../views/HomeBarcode.vue'

import Students from '../views/students/ListStudent'
import CreateStudent from '../views/students/CreateStudent'
import EditStudent from '../views/students/EditStudent'
import DetailsStudent from '../views/students/DetailsStudent'

import Groups from '../views/groups/ListGroup'
import CreateGroup from '../views/groups/CreateGroup'
import EditGroup from '../views/groups/EditGroup'
import DetailsGroup from '../views/groups/DetailsGroup'

import TakeAttendance from '../views/attendance/TakeAttendance'
import AttendanceReport from '../views/attendance/AttendanceReport'
import AbsentReport from '../views/attendance/AbsentReport'

import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    { path: '/students', name: 'students', component: Students, meta: { requiresAuth: true } },
    { path: '/students/create', name: 'createStudent', component: CreateStudent, meta: { requiresAuth: true } },
    { path: '/students/edit/:id', name: 'editStudent', component: EditStudent, props: true, meta: { requiresAuth: true } },
    { path: '/students/details/:id', name: 'detailsStudent', component: DetailsStudent, props: true, meta: { requiresAuth: true } },

    { path: '/groups', name: 'groups', component: Groups, meta: { requiresAuth: true } },
    { path: '/groups/create', name: 'createGroup', component: CreateGroup, meta: { requiresAuth: true } },
    { path: '/groups/edit/:id', name: 'editGroup', component: EditGroup, props: true, meta: { requiresAuth: true } },
    { path: '/groups/details/:id', name: 'detailsGroup', component: DetailsGroup, props: true, meta: { requiresAuth: true } },

    { path: '/attendance/', name: 'takeAttendacne', component: TakeAttendance, meta: { requiresAuth: true } },
    { path: '/attendance/report', name: 'AttendanceReport', component: AttendanceReport, meta: { requiresAuth: true } },
    { path: '/attendance/absents', name: 'AbsentReport', component: AbsentReport, meta: { requiresAuth: true } },

    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/barcode',
        name: 'barcode',
        component: Barcode
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(route => route.meta.requiresAuth)) {
        const jwt = localStorage.getItem("jwt")
        if (jwt) {
            next()
        } else {
            next({ name: 'login' })
        }
    } else {
        next()
    }
})

export default router